/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getDraftRoutingEarlyRequestRpc = {
  serviceName: 'com.hubspot.forms.routing.rpc.LegacyFormsRoutingService',
  rpcName: 'getDraftRouting',
  auth: 'app',
  fingerprint: 'tI2UMAmmJrURo_XLbwRzYGlPV6N2pY-f',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};
export const getRoutingEvaluationEarlyRequestRpc = {
  serviceName: 'com.hubspot.forms.routing.rpc.LegacyFormsRoutingService',
  rpcName: 'getRoutingEvaluation',
  auth: 'app',
  fingerprint: 'ecJaA08ufWYPXATE2y7RRmlPV6N2pY-f',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};